import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { SiteSettings } from '@/types';
import { DEFAULT_SETTINGS } from '@/config/defaults';

let cached: SiteSettings | null = null;

export function useSettings(): SiteSettings {
    const [settings, setSettings] = useState<SiteSettings>(cached ?? DEFAULT_SETTINGS);

    useEffect(() => {
        if (cached) return;
        api.getSettings().then((res) => {
            if (res.data) {
                // Worker responses are {data: settings}, and ApiClient wraps the
                // body again — unwrap defensively (same idiom as the admin managers).
                const raw = res.data as SiteSettings | { data: SiteSettings };
                const value = 'data' in raw && !('socialYoutube' in raw) ? raw.data : (raw as SiteSettings);
                cached = { ...DEFAULT_SETTINGS, ...value };
                setSettings(cached);
            }
        });
    }, []);

    return settings;
}
